import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from '../i18n/LanguageContext'
import { browserPlanStorage } from '../lib/planDrafts.js'
import { SAVED_LISTINGS_KEY, readSavedListings, savedListingKey, toggleSavedListing, savedListingMessages } from '../lib/savedListings.js'
import './SavedListingFeedback.css'

export function useSavedListings() {
  const [state, setState] = useState(() => readSavedListings(browserPlanStorage()))
  const current = useRef(state)
  const [feedback, setFeedback] = useState(state.error)
  const accept = next => { current.current = next; setState(next) }
  useEffect(() => {
    const changed = event => {
      if (event.key !== null && event.key !== SAVED_LISTINGS_KEY) return
      const next = readSavedListings(browserPlanStorage())
      accept(next); setFeedback(next.error)
    }
    window.addEventListener('storage', changed)
    return () => window.removeEventListener('storage', changed)
  }, [])
  const toggle = car => {
    const next = toggleSavedListing(browserPlanStorage(), current.current, car)
    accept(next); setFeedback(next.error || next.action)
  }
  return { savedListings: state.items, savedListingIds: new Set(state.items.map(savedListingKey).filter(Boolean)),
    toggleSaveListing: toggle, feedback, dismissFeedback: () => setFeedback(null) }
}
export default function SavedListingFeedback({ feedback, onDismiss }) {
  const { t } = useTranslation()
  if (!feedback || !savedListingMessages[feedback]) return null
  const error = !['saved', 'removed'].includes(feedback)
  return <aside className={`saved-listing-feedback ${error ? 'is-error' : ''}`} aria-label={t('Saved listing status')}>
    <p role={error ? 'alert' : 'status'}>{t(savedListingMessages[feedback])}</p>
    <button type="button" onClick={onDismiss}>{t('Dismiss saved listing message')}</button>
  </aside>
}
